import { Card, Skeleton, cn } from "ui";

export type EntityCardSkeletonProps = {
  /** Header image/icon size — mirrors `EntityCard`'s `imageDimensions`. */
  imageDimensions?: 56 | 72;
  /** Render the divider + body line below the header. */
  withBody?: boolean;
  className?: string;
};

const imageDimensionsClasses = {
  56: "h-[56px] w-[56px]",
  72: "h-[72px] w-[72px]",
};

export const EntityCardSkeleton = ({
  imageDimensions = 72,
  withBody = true,
  className,
}: EntityCardSkeletonProps) => (
  <Card disableHover className={cn("flex flex-col pb-3", className)}>
    {/* Header */}
    <div className="mb-4 flex items-center gap-4">
      <Skeleton
        className={cn(
          "shrink-0 rounded-md",
          imageDimensionsClasses[imageDimensions]
        )}
      />
      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-3 w-24" />
      </div>
    </div>

    {withBody && (
      <div className="-mx-4 border-t border-t-foundations-subtle px-4 py-3">
        <Skeleton className="h-4 w-32 md:my-[7px]" />
      </div>
    )}
  </Card>
);
